import React from 'react';
import Layout from '../components/layout';
import PrivacyPolicy from '../components/PrivacyPolicy';
import '../style/index.scss';

const PrivacyPolicyPage = () => (
  <Layout page='privacy-policy'>
    <div id='privacy-policy-wrapper'>
      <PrivacyPolicy />
    </div>
  </Layout>
);

export default PrivacyPolicyPage;
